const UploadImage = {
  linkSeparator: ' - ',
  filesToUpload: [],
  // Dados do Cloudinary
  config: {
    cloudName: 'jxu01c8z', // mudar esse Andrews
    uploadPreset: 'ml_default',
    maxSize: 10 * 1024 * 1024, // 10MB
    allowedTypes: [
      'image/png',
      'image/jpg',
      'image/jpeg',
      'image/webp'
    ]
  },

  setFilesToUpload: function (files = []) {
    const normalizedFiles = Array.isArray(files) ? files.filter(Boolean) : files ? [files] : []

    this.filesToUpload = normalizedFiles

    if (typeof window !== 'undefined') {
      window.filesToUpload = normalizedFiles
    }
  },

  clearSelectedFiles: function () {
    this.setFilesToUpload([])
  },

  // Validacao do tipo do arquivo
  validateFileType: function (file) {
    if (!this.config.allowedTypes.includes(file.type)) {
      console.error('Formato nao permitido do arquivo: ', file)
      return false
    }
    console.log('Formato do arquivo permitido: ', file)
    return true
  },

  validateFileSize: function (file) {
    if (file.size > this.config.maxSize) {
      console.error('Tamanho maximo do arquivo permitido e 10MB')
      return false
    } else {
      console.log('Tamanho do arquivo permitido: ', file.size)
      return true
    }
  },

  handleImages: function () {
    console.log('handle images')

    const customizationImages = document.querySelectorAll('[data-customization-file]')

    if (!customizationImages.length) return

    customizationImages.forEach(customizationImage => {
      const labelElement = customizationImage.nextElementSibling
      const customizationFileName = labelElement && labelElement.nextElementSibling && labelElement.nextElementSibling.matches('[data-customization-file-name]')
        ? labelElement.nextElementSibling
        : customizationImage.parentElement.querySelector('[data-customization-file-name]')
      const customizationError = customizationFileName && customizationFileName.nextElementSibling && customizationFileName.nextElementSibling.matches('[data-customization-error]')
        ? customizationFileName.nextElementSibling
        : customizationImage.parentElement.querySelector('[data-customization-error]')
      const defaultLabel = 'Nenhum arquivo selecionado'

      customizationImage.addEventListener('change', (event) => {
        const files = Array.from(event.target.files || [])

        if (!files.length) return

        const hasInvalidType = files.some(file => !UploadImage.validateFileType(file))
        const hasInvalidSize = files.some(file => !UploadImage.validateFileSize(file))

        if (!hasInvalidType && !hasInvalidSize) {
          UploadImage.setFilesToUpload(files)

          if (customizationFileName) {
            customizationFileName.textContent = files.length === 1
              ? (files[0].name || defaultLabel)
              : `${files.length} arquivos selecionados`
          }

          if (customizationError) {
            customizationError.textContent = ''
          }
        } else {
          UploadImage.clearSelectedFiles()
          event.target.value = ''

          if (customizationFileName) {
            customizationFileName.textContent = defaultLabel
          }

          if (customizationError) {
            customizationError.textContent = hasInvalidType
              ? 'Formato invalido! Envie arquivos nos formatos permitidos'
              : 'Tamanho maximo permitido excedido, os arquivos devem ter no maximo 10MB'

            setTimeout(() => {
              customizationError.textContent = ''
            }, 3000)
          }
        }
      })
    })
  },

  handleUpload: async function (files = [], customizationInput) {
    try {
      const normalizedFiles = Array.isArray(files) ? files.filter(Boolean) : files ? [files] : []

      if (!normalizedFiles.length) return []

      const uploadedLinks = []

      for (const file of normalizedFiles) {
        ///////////////////////////////////////////
        //// Implementacao com Cloudinary
        ///////////////////////////////////////////

        const formData = new FormData()
        formData.append('file', file)
        formData.append('upload_preset', this.config.uploadPreset)
        formData.append('folder', 'user_uploads') // Configurado no Cloudinary
        formData.append('tags', 'web_upload') // Para melhor gerenciamento
        formData.append('context', `filename=${encodeURIComponent(file.name)}`)

        const response = await fetch(
          `https://api.cloudinary.com/v1_1/${this.config.cloudName}/image/upload`,
          {
            method: 'POST',
            body: formData,
            referrerPolicy: 'no-referrer' // Header de seguranca
          }
        )

        if (!response.ok) {
          const error = await (response.json())
          throw new Error(error.message || 'Erro no upload')
        }

        const data = await response.json()

        console.log('link gerado: ', data.secure_url)
        uploadedLinks.push(data.secure_url)
      }

      // Insere o link para a imagem no Cloudinary no input da customizacao
      // E necessario remover o 'disabled' do atributo, caso ele esteja disabled o input nao e enviado no form
      if (customizationInput) {
        customizationInput.value = uploadedLinks.join(this.linkSeparator)
        customizationInput.removeAttribute('disabled')
      }

      this.clearSelectedFiles()

      return uploadedLinks

    } catch (error) {
      console.error('Erro no upload: ', error)
      if (typeof this.showError === 'function') {
        this.showError(error.message)
      }
      throw error
    }
  }
}

export default UploadImage

